import { newSpecPage } from '@stencil/core/testing';
import { NylasEventDuration } from '../nylas-event-duration';
import { InputDropdown } from '../../../design-system/input-dropdown/input-dropdown';
import { h } from '@stencil/core';
import { SelectDropdown } from '../../../design-system/select-dropdown/select-dropdown';
import { selectedConfiguration } from '@/utils/test-utils';

describe('nylas-event-duration', () => {
  const config = {
    ...selectedConfiguration,
    availability: {
      ...selectedConfiguration.availability,
      duration_minutes: 60,
    },
  };
  let page: any;

  beforeEach(async () => {
    page = await newSpecPage({
      components: [InputDropdown, SelectDropdown, NylasEventDuration],
      template: () => {
        return <nylas-event-duration name="eventDuration" selectedConfiguration={config} />;
      },
    });
    await page.waitForChanges();
  });

  afterEach(() => {
    page?.root?.remove();
  });

  it('renders', async () => {
    expect(page.root).toMatchSnapshot();
  });

  it('renders hour duration input options with 1 hour increments when hours option is selected', async () => {
    const inputDropdown = page.root.shadowRoot.querySelector('input-dropdown');
    const input = inputDropdown.shadowRoot.querySelector('input');
    expect(input).not.toBeNull();
    input.click();
    await page.waitForChanges();
    expect(page.root).toMatchSnapshot();
  });
});
